<script>
export default {
	name: 'Termeni si conditii',
	data: () => {
		return {};
	},
	methods: {},
};
</script>

<template>
    <div class="container mx-auto px-4 sm:py-8 sm:container sm:mx-auto">
    <div class="maintitlecont">
      <h1 class="maintitle">{{$t('terms_and_conditions')}}</h1>
    </div>
    <div class="termeni">
        <h3 style="font-weight: 600;">{{$t('terms_intro')}}</h3>
        <p>{{$t('terms_detail_1')}}</p>
        <p>{{$t('terms_detail_2')}}</p>
        <p>{{$t('terms_detail_3')}}</p>
        <p>{{$t('terms_detail_4')}}</p>
        <p>{{$t('terms_detail_5')}}</p>
        <p>{{$t('terms_detail_6')}}</p>
        <p>{{$t('terms_detail_7')}}</p>
        <p>{{$t('terms_detail_8')}}</p>
        <p>{{$t('terms_detail_9')}}</p>
        <p>{{$t('terms_detail_10')}}</p>
        <p>{{$t('terms_detail_11')}}</p>
        <p>{{$t('terms_detail_12')}}</p>
        <p>{{$t('terms_detail_13')}}</p>
        <p>{{$t('terms_detail_14')}}</p>
        <p>{{$t('terms_detail_15')}}</p>
        <p>{{$t('terms_detail_16')}}</p>
        <p>{{$t('terms_detail_17')}}</p>
    </div>
    </div>
</template>

<style scoped>
.termeni p {
    padding: 15px 0;
    border-bottom: 1px solid #dddcdc;
}

.termeni p:last-child {
    border: none;
}
</style>
